var _use, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgGoogleCloudPlatform = function SvgGoogleCloudPlatform(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 81 66",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google-cloud-platform_svg__a",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "google-cloud-platform_svg__a",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M50.764 17.73h2.44l6.953-6.954.34-2.953C47.556-3.602 27.805-2.368 16.38 10.574a31.26 31.26 0 0 0-6.733 12.5 3.76 3.76 0 0 1 2.44-.144l13.907-2.295s.706-1.172 1.076-1.1a17.35 17.35 0 0 1 23.742-1.806h-.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M70.064 23.074a31.3 31.3 0 0 0-9.441-15.223l-9.758 9.758a17.35 17.35 0 0 1 6.368 13.763v1.734a8.69 8.69 0 0 1 8.687 8.687 8.69 8.69 0 0 1-8.687 8.687H39.86l-1.734 1.758v10.42l1.734 1.734h17.374c12.476.096 22.67-9.94 22.767-22.416a22.6 22.6 0 0 0-9.936-18.901z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M22.46 64.282h17.374V50.375H22.46a8.65 8.65 0 0 1-3.587-.783l-2.44.76-7.002 6.954-.6 2.44a22.42 22.42 0 0 0 13.638 4.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    d: "M22.46 19.17C9.98 19.242-.072 29.418 0 41.9a22.58 22.58 0 0 0 8.822 17.773l10.075-10.075a8.69 8.69 0 0 1-4.341-11.492 8.69 8.69 0 0 1 11.492-4.341 8.7 8.7 0 0 1 4.34 4.34L40.463 28.03a22.54 22.54 0 0 0-18.003-8.86"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleCloudPlatform);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;